import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/site/Reveal";
import { SERVICES } from "@/lib/site";

const Card = ({ s, large, delay }) => (
  <Reveal delay={delay} className={`h-full ${large ? "md:col-span-7 md:row-span-2" : "md:col-span-5"}`}>
    <Link to={`/services#${s.slug}`} data-testid={`home-service-card-${s.slug}`}
      className="group relative flex h-full min-h-[360px] flex-col justify-end overflow-hidden rounded-[1.75rem] bg-[var(--navy)] text-white">
      <img src={s.image} alt={s.alt} loading="lazy"
        className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1.2s] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-[var(--navy-deep)] via-[var(--navy-deep)]/55 to-transparent" />
      <span className="absolute top-6 right-6 grid h-12 w-12 place-items-center rounded-full bg-white/15 backdrop-blur-md transition-[background-color,transform] duration-500 group-hover:bg-[var(--green)] group-hover:rotate-45">
        <ArrowUpRight className="h-5 w-5" />
      </span>
      <div className="relative p-7 sm:p-9">
        <p className="font-display text-sm text-[var(--green-bright)]">{s.number}</p>
        <h3 className={`mt-2 font-display font-bold tracking-tight ${large ? "text-3xl sm:text-4xl" : "text-2xl sm:text-3xl"}`}>{s.title}</h3>
        <p className="mt-3 max-w-md text-slate-200 leading-relaxed">{s.short}</p>
        {large && (
          <ul className="mt-6 hidden sm:grid grid-cols-2 gap-x-6 gap-y-2 text-sm text-slate-200">
            {s.items.slice(0, 4).map((it) => (
              <li key={it} className="flex items-start gap-2"><Check className="mt-0.5 h-4 w-4 shrink-0 text-[var(--green-bright)]" />{it}</li>
            ))}
          </ul>
        )}
      </div>
    </Link>
  </Reveal>
);

export const ServicesBento = () => (
  <section className="bg-[var(--grey)] py-20 md:py-28" data-testid="home-services">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid gap-6 md:grid-cols-12 md:items-end mb-12">
        <SectionHeading className="md:col-span-8" eyebrow="What we do" title="Three services. One dependable local team." />
        <Reveal delay={0.1} className="md:col-span-4 md:text-right">
          <Link to="/services" data-testid="home-all-services-link" className="link-underline font-semibold text-[var(--navy)]">View all services →</Link>
        </Reveal>
      </div>
      <div className="grid gap-5 md:grid-cols-12 md:auto-rows-[minmax(300px,1fr)]">
        <Card s={SERVICES[0]} large delay={0} />
        <Card s={SERVICES[1]} delay={0.1} />
        <Card s={SERVICES[2]} delay={0.2} />
      </div>
    </div>
  </section>
);
